<div class="filter-container">
  <div class="filter-header">
    <div class="filter-title mt-1">
      {{ tableFilter().title }}
    </div>
    <lib-button [type]="ButtonType.tertiary" [size]="InputSize.small" (buttonClick)="resetClicked()" i18n>
      Reset
    </lib-button>
  </div>
  <div class="mt-3 d-flex flex-column gap-3">
    <lib-checkbox [size]="InputSize.small" [selected]="useRange()" (checkboxClick)="rangeCheckboxClicked()" i18n>
      Range
    </lib-checkbox>
    @if (!useRange()) {
      <div>
        <label class="form-input-label mb-1" [for]="exactValueFormControlId" i18n>Amount</label>
        <lib-text-input [type]="'number'" [formControl]="exactValueFormControl" [controlId]="exactValueFormControlId">
        </lib-text-input>
      </div>
    } @else {
      <div>
        <label class="form-input-label mb-1" [for]="minValueFormControlId" i18n>Minimum Amount</label>
        <lib-text-input [type]="'number'" [formControl]="minValueFormControl" [controlId]="minValueFormControlId">
        </lib-text-input>
      </div>
      <div>
        <label class="form-input-label mb-1" [for]="maxValueFormControlId" i18n>Maximum Amount</label>
        <lib-text-input [type]="'number'" [formControl]="maxValueFormControl" [controlId]="maxValueFormControlId">
        </lib-text-input>
      </div>
    }
  </div>
</div>
